import { axiosPost } from "@root/shared/utils";
import { type AxiosError } from "axios";
import { useEffect, useState } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const newrelic: any;

type UseContactAcquiredButtonParams = {
  requestProfilePath: string;
  isScout: boolean;
  isSalonTour: boolean;
  clientMessageTimelinePagePath: string;
};

type ReturnType = {
  isShow: boolean;
  isChecked: boolean;
  isPossibleToSubmit: boolean;
  handleShowModal: () => void;
  handleCloseModal: () => void;
  handleChangeCheckbox: () => void;
  handleRequestProfile: () => Promise<void>;
};

export const useContactAcquiredButton = ({
  requestProfilePath,
  isScout,
  isSalonTour,
  clientMessageTimelinePagePath,
}: UseContactAcquiredButtonParams): ReturnType => {
  const [isShow, setIsShow] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isPossibleToSubmit, setIsPossibleToSubmit] = useState(true);

  const handleShowModal = () => {
    setIsShow(true);
  };

  const handleCloseModal = () => {
    setIsShow(false);
  };

  const handleChangeCheckbox = () => {
    setIsChecked((prev) => !prev);
  };

  const handleRequestProfile = async () => {
    await axiosPost
      .post(requestProfilePath, undefined, {
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
      .then(() => {
        // 連絡先取得後は常に企業側のメッセージ詳細(タイムライン)画面に遷移
        window.location.href = clientMessageTimelinePagePath;
      })
      .catch((error: AxiosError) => {
        if (typeof newrelic !== "undefined") {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          newrelic.noticeError(error.message);
        }
        const data = error.response?.data as Record<string, unknown> | undefined;
        const redirectToJobEntryPath =
          typeof data?.error_redirect_url === "string" ? data.error_redirect_url : null;

        if (redirectToJobEntryPath) {
          window.location.href = redirectToJobEntryPath;
          return;
        }
        alert("エラーが発生しました。画面を更新します。");
        window.location.reload();
      });
  };

  // 確認のチェック済みか、チェック不要な場合は送信可能にする
  useEffect(() => {
    if (isChecked) {
      setIsPossibleToSubmit(true);
      return;
    }
    if (!isScout && !isSalonTour) {
      setIsPossibleToSubmit(true);
      return;
    }
    setIsPossibleToSubmit(false);
  }, [isChecked, isSalonTour, isScout]);

  return {
    isShow,
    isChecked,
    isPossibleToSubmit,
    handleShowModal,
    handleCloseModal,
    handleChangeCheckbox,
    handleRequestProfile,
  };
};
